import { IKImage } from "imagekitio-next";
import React from "react";

type StoreLogoProps = {
  imageName: string;
  alt: string;
  className?: string;
};

const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL_BLOG_IMG;

const LogoDisplayWidth = 147;
const LogoDisplayHeight = 40;

const RetinaScaleFactor = 3;

const YawakitLogo = (props: StoreLogoProps) => {
  const imagePath = props?.imageName || "default_image.jpg";

  return (
    <IKImage
      urlEndpoint={urlEndpoint}
      path={imagePath}
      transformation={[{ quality: "100" }]}
      width={LogoDisplayWidth * RetinaScaleFactor}
      height={LogoDisplayHeight * RetinaScaleFactor}
      alt={props?.alt}
      loading="lazy"
      className={props.className ?? ""}
      lqip={{ active: false }}
      style={{
        width: `${LogoDisplayWidth}px`,
        height: `${LogoDisplayHeight}px`,
        objectFit: "contain",
      }}
      sizes={`${LogoDisplayWidth}px`}
    />
  );
};

export default YawakitLogo;
